const cleanIDSelection = (ids) => {
  if (!ids) return [];
  return ids
    .replace(/\n/g, ",") // Accept both comma and newline as separator
    .split(",")
    .map((id) => id && id.trim())
    .filter((id) => id); // Remove empty values
};
export default cleanIDSelection;
